import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import GoogleTagManager from 'ta-react-gtm';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.css';
import AppStore from './redux/store/AppStore';
import routes from './routes/routes';
import RestBuilder from './rest/RestBuilder';
import FetchAnalyticsTrackingCodeService from './services/FetchAnalyticsTrackingCodeService';
import GTMDataLayerHack from './GTMDataLayerHack';
import './index.scss';
import './fonts/font.scss';
import './fonts/font-awesome-4.6.3/scss/font-awesome.scss';

const init = async () => {
  const history = syncHistoryWithStore(browserHistory, AppStore);
  const gtmTrackingCode = await new FetchAnalyticsTrackingCodeService(new RestBuilder().build()).requestGTM();

  const shouldScroll = (pathname) => {
    const [, path] = pathname.split('/');

    return path !== 'support-centre';
  };

  const onUpdate = () => {
    const pathname = browserHistory.getCurrentLocation().pathname;

    if (shouldScroll(pathname)) {
      window.scrollTo(0, 0);
    }
  };

  ReactDOM.render(
    <div>
      <GoogleTagManager gtmId={gtmTrackingCode} category="home" pagetype="homepage" />
      <GTMDataLayerHack />
      <Provider store={AppStore}>
        <Router
          onUpdate={onUpdate}
          history={history}
          routes={routes}
        />
      </Provider>
    </div>,
    document.getElementById('root')
  );
};

init();



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/